import { useEffect, useRef, useState } from "react";

export default function LazyImg({ src, alt, className = "", ...rest }) {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    if (ref.current && ref.current.complete && ref.current.naturalWidth > 0) {
      setLoaded(true);
    }
  }, [src]);

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      loading="lazy"
      className={`${className} ${loaded ? "loaded" : ""}`.trim()}
      onLoad={() => setLoaded(true)}
      {...rest}
    />
  );
}
